import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { Box, SubmitButton } from '@staffino/primitive-controls';
import styled from '@emotion/styled';

const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
};

const getCookie = (name: string) => {
  if (typeof document === 'undefined') {
    return null;
  }

  const nameEQ = `${name}=`;

  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

const ConsentWrapper = styled(Box)`
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  padding: 20px;
  max-width: 450px;
  border-radius: 5px;
  box-shadow:
    10px 10px 20px 5px rgba(88, 100, 116, 0.2),
    -10px 10px 20px 5px rgba(88, 100, 116, 0.2);
  z-index: 1000;
  text-align: center;

  bottom: 20px;
  right: 50%;
  transform: translateX(50%);
  width: 90vw;
`;
const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(!getCookie('cookieConsent'));

  const handleAccept = () => {
    setCookie('cookieConsent', 'accepted', 365);
    setIsVisible(false);
  };

  const handleDecline = () => {
    setCookie('cookieConsent', 'declined', 365);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <ConsentWrapper>
      <h3 style={{ margin: '0' }}>
        🍪 <Trans>Cookies consent</Trans>
      </h3>
      <p>
        <Trans>
          {
            'We use cookies to improve your browsing journey. Please accept cookies to ensure the best experience.'
          }
        </Trans>
      </p>
      <SubmitButton onClick={handleAccept} variant="primary">
        <Trans>Accept</Trans>
      </SubmitButton>
      <SubmitButton
        onClick={handleDecline}
        variant="light"
        style={{ borderColor: '#d8e1eb', marginTop: '0.5rem' }}
      >
        <Trans>Decline</Trans>
      </SubmitButton>
    </ConsentWrapper>
  );
};

export default CookieConsent;
